import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import AbstractCommand from '../AbstractCommand';
import Signals from '../../signals/Signals';

import offerDelete from '../../requests/offers/offerDelete';

/**
 *
 */
export default class DeleteOfferCommand extends AbstractCommand {

	/**
	 *
	 * @param offersStore OffersStore
	 * @param offerModel OfferModel
	 * @param company Company
	 */
	constructor(offersStore, offerModel, company) {
		super();

		this.offersStore = offersStore;
		this.offerModel = offerModel;
		this.company = company;
	}

	/**
	 *
	 * @param success
	 * @param error
	 */
	execute(success, error) {
		return offerDelete(this.company.id, this.offerModel.id)
			.then((response) => {

				this._removeOfferFromStore();
				this._showSuccessMessage();

				if(success) {
					success(response);
				}
			})
			.catch((err) => {

				Signals.Error.dispatch(err);

				if(error) {
					error(err);
				}
			});
	}

	/**
	 *
	 * @private
	 */
	_removeOfferFromStore() {
		this.offersStore.removeOffer(this.offerModel.id);
	}

	/**
	 *
	 * @private
	 */
	_showSuccessMessage() {
		// Show message
		Signals.ShowMessageDialog.dispatch(
			(<FormattedHTMLMessage id="offer.removed.message"
								   values={{offerNr: this.offerModel.offerNr}}/>)
		);
	}
}
